import http from './client';
import { withParams } from './utils';

export const leaveArticlesApi = {
  list: (params = {}) => http.get('/leave-articles', withParams(params)),
  create: (body) => http.post('/leave-articles', body),
  get: (id) => http.get(`/leave-articles/${id}`),
  update: (id, body) => http.put(`/leave-articles/${id}`, body),
  deactivate: (id) => http.delete(`/leave-articles/${id}`),
  listRules: (id, params = {}) => http.get(`/leave-articles/${id}/rules`, withParams(params)),
  createRule: (id, body) => http.post(`/leave-articles/${id}/rules`, body),
  listRequirements: (id) => http.get(`/leave-articles/${id}/article-requirements`),
  createRequirement: (id, body) => http.post(`/leave-articles/${id}/article-requirements`, body),
};

export const legalDocumentsApi = {
  list: (params = {}) => http.get('/legal-documents', withParams(params)),
  create: (body) => http.post('/legal-documents', body),
  get: (id) => http.get(`/legal-documents/${id}`),
  update: (id, body) => http.put(`/legal-documents/${id}`, body),
};

export const leaveArticleRulesApi = {
  update: (id, body) => http.put(`/leave-article-rules/${id}`, body),
  deactivate: (id) => http.delete(`/leave-article-rules/${id}`),
};

export const leaveArticleRequirementsApi = {
  update: (id, body) => http.put(`/leave-article-requirements/${id}`, body),
  deactivate: (id) => http.delete(`/leave-article-requirements/${id}`),
};

export const leaveRequestsApi = {
  list: (params = {}) => http.get('/leave-requests', withParams(params)),
  create: (body) => http.post('/leave-requests', body),
  get: (id) => http.get(`/leave-requests/${id}`),
  update: (id, body) => http.put(`/leave-requests/${id}`, body),
  submit: (id) => http.post(`/leave-requests/${id}/submit`),
  approve: (id, body = {}) => http.post(`/leave-requests/${id}/approve`, body),
  reject: (id, reason) => http.post(`/leave-requests/${id}/reject`, { reason }),
  observe: (id, observation) => http.post(`/leave-requests/${id}/observe`, { observation }),
  cancel: (id, reason) => http.post(`/leave-requests/${id}/cancel`, { reason }),
  submitFinalDocument: (id, body) => http.post(`/leave-requests/${id}/final-document`, body),
  deleteFinalDocument: (id) => http.delete(`/leave-requests/${id}/final-document`),
  addDocument: (id, file, documentType) => {
    const formData = new FormData();
    formData.append('file', file);
    if (documentType) {
      formData.append('document_type', documentType);
    }
    return http.post(`/leave-requests/${id}/documents`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  requirements: (id) => http.get(`/leave-requests/${id}/requirements`),
};

export const leaveRequestRequirementsApi = {
  pass: (id, body = {}) => http.post(`/leave-request-requirements/${id}/pass`, body),
  fail: (id, body = {}) => http.post(`/leave-request-requirements/${id}/fail`, body),
  notApplicable: (id, body = {}) => http.post(`/leave-request-requirements/${id}/not-applicable`, body),
};

export const leaveRequestDocumentsApi = {
  approve: (id) => http.post(`/leave-request-documents/${id}/approve`),
  reject: (id, reason) => http.post(`/leave-request-documents/${id}/reject`, { reason }),
  getFile: (id) => http.get(`/leave-request-documents/${id}/file`, { responseType: 'blob' }),
};

const blobFromFileResponse = async (fileResponse) => {
  const contentType = fileResponse.headers?.['content-type'] || 'application/octet-stream';
  const data = fileResponse.data;
  if (contentType.includes('application/json') && data instanceof Blob) {
    const text = await data.text();
    let message = 'No se pudo abrir el documento.';
    try {
      message = JSON.parse(text).message || message;
    } catch {
      // keep default
    }
    throw new Error(message);
  }
  return data instanceof Blob
    ? new Blob([data], { type: data.type || contentType })
    : new Blob([data], { type: contentType });
};

export const getLeaveDocumentBlob = async (documentId) => {
  const fileResponse = await leaveRequestDocumentsApi.getFile(documentId);
  return blobFromFileResponse(fileResponse);
};

export const getLeaveDocumentViewerUrl = async (documentId) => {
  const blob = await getLeaveDocumentBlob(documentId);
  return URL.createObjectURL(blob);
};

export const leaveAvailabilityApi = {
  get: (userId, params = {}) => http.get(`/users/${userId}/leave-availability`, withParams(params)),
  balances: (userId, params = {}) => http.get(`/users/${userId}/leave-balances`, withParams(params)),
};
